<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>{{pageInfo}}
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="话术内容" class="mb-10">
            <el-input type="textarea" maxlength="300" show-word-limit v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item label="关键词" class="mb-10">
            <el-tag
                    :key="tag"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
            >{{tag}}
            </el-tag>
            <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
            ></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加</el-button>
          </el-form-item>
          <el-form-item label="所在分组" class="mb-30">
            <el-select v-model="form.group_id" placeholder="请选择" size="small">
              <el-option
                      v-for="item in speechList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="goback">取消并返回</el-button>
            <el-button type="primary" @click="onSubmit" size="small">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "speechAdd",
    data() {
      return {
        form: {
          group_id: '',
          content: '',
          keyword: ''
        },
        dynamicTags: [],
        inputVisible: false,
        inputValue: "",
        value: "",
        speechList: [],
        // pageInfo: this.$route.query,
        pageInfo: '新增话术',
        pageOption: null
      };
    },
    created() {
     let optionList=''
       if(sessionStorage.getItem("menu1")){
         if(this.$route.params.option){
            optionList  = JSON.parse(this.$route.params.option)
            this.pageInfo = (this.$route.params.type=='edit' )? '修改话术':'新增话术'
            this.pageOption = optionList
            this.form.group_id = optionList.group_id
            this.form.content = optionList.content
            this.dynamicTags = optionList.keyword.split(',')
  
         }
       }else{
          if (this.$route.query.option) {
            this.pageInfo = (this.$route.query.type=='edit' )? '修改话术':'新增话术'
            optionList = JSON.parse(this.$route.query.option)
            this.pageOption = optionList
            this.form.group_id = optionList.group_id
            this.form.content = optionList.content
            this.dynamicTags = optionList.keyword.split(',')
          }
       }
    
      this.InitFn()
    },
    methods: {
      InitFn(option) {
        this.axios
            .post('companyadmin/verbal_group/index', {page: this.speechListPage})
            .then(response => {
              if (response.data.code == 0) {
                this.speechList = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
      },
      onSubmit() {
        if (!this.form.content) {
          this.$message({
            message: '请填写话术内容',
            type: 'warning'
          });
          return
        }
        if (!this.dynamicTags.length) {
          this.$message({
            message: '请填写关键词',
            type: 'warning'
          });
          return
        }
          if (!this.form.group_id) {
            this.$message({
              message: '请选择所在的分组',
              type: 'warning'
            });
            return
          }
          this.form.keyword = this.dynamicTags.join(',')
          let url_ = 'companyadmin/verbal_trick/add'
          let data_ = this.form
          let message = '添加成功！'
          if (this.pageOption) {
            url_ = 'companyadmin/verbal_trick/edit'
            data_.trick_id = this.pageOption.id
            message = '编辑成功！'
          }
          this.axios
              .post(url_, data_)
              .then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    message: message,
                  });
                  this.$router.go(-1);
                } else {
                }
              })
              .catch(response => {
              });
        }
      ,
        goback()
        {
          this.$router.go(-1);
        }
      ,
        handleClose(tag)
        {
          this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        }
      ,

        showInput()
        {
          this.inputVisible = true;
          this.$nextTick(_ => {
            this.$refs.saveTagInput.$refs.input.focus();
          });
        }
      ,
        handleInputConfirm()
        {
          let inputValue = this.inputValue;
          if (inputValue) {
            this.dynamicTags.push(inputValue);
          }
          this.inputVisible = false;
          this.inputValue = "";
        }
      }
    };
</script>
